<template>
  <div id="content">
    <div v-if="newsData.title &&newsData.titleShow == 1">
      <div class="title">{{newsData.title}}</div>
      <div class="titlebtm"></div>
    </div>
    <div class="newsimgbox clearfix">
      <div class="newsList" v-for="(news,index) in newsList" :key="index">
        <div v-if="news.titleShow == 1" class="newstitle">
          <div class="title">{{news.title}}</div>
          <div class="titlebtm"></div>
          <span class="more font14" @click="tonewsList()" v-if="newsData.moreShow === 1">更多<img style="height: 12px;margin-left: 2px;position: relative;top: 1px;" src="/static/images/more.png" alt=""></span>
        </div>
        <div class="fl">
          <div class="imgbox pointer" v-if="dataobj[news.id]">
            <a v-if="dataobj[news.id][0].recordTypeStr == '外部报道'" :href="dataobj[news.id][0].myLink" target="_blank">
              <img :src="dataobj[news.id] | resetImg('arr',$configUrl.futureImgUrl)" alt="">
              <p class="font20">{{dataobj[news.id]?dataobj[news.id][0].firstTitle :''}}</p>
              <div class="mark"></div>
            </a>
            <router-link v-else :to="{name:'newsDetail', query: {id:dataobj[news.id][0].id}}">
              <img :src="dataobj[news.id] | resetImg('arr',$configUrl.futureImgUrl)" alt="">
              <p class="font20">{{dataobj[news.id]?dataobj[news.id][0].firstTitle :''}}</p>
              <div class="mark"></div>
            </router-link>
          </div>
        </div>
        <div class="fr">
          <div class="frtop font24"><img src="/static/images/newsIcon.png" alt="">最新资讯<span class="font16 half">RANKING(24小时）</span></div>
          <div class="newslist">
            <div class="frnewsbox pointer" v-for="(item,i) in fesetData(dataobj[news.id])" :key="i">
              <a v-if="item.recordTypeStr == '外部报道'" :href="item.myLink" target="_blank">
                <div class="frnewsnum">{{i+1}}</div>
                <div class="frnewscon">
                  <div class="frnewscontitle font20">{{item.firstTitle}}</div>
                  <div class="frnewscontent font14">{{item.remark}}</div>
                </div>
              </a>
              <router-link v-else :to="{name:'newsDetail', query: {id:item.id}}">
                <div class="frnewsnum">{{i+1}}</div>
                <div class="frnewscon">
                  <div class="frnewscontitle font20">{{item.firstTitle}}</div>
                  <div class="frnewscontent font14">{{item.remark}}</div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '../../utils/api.js'
  export default {
    name: 'eduNewsThree',
    props:{
      newsData:{
        type:Object,
        default:null
      }
    },
    data() {
      return {
        newsList: [],
        dataobj: {},
      }
    },
    computed:{
      fesetData(){
        return(arr)=>{
          return arr && arr.length > 0?arr.slice(1,5):[]
        }
      }
    },
    filters:{
      resetImg(val, type,imgurl){
        const value = val
        let url
        if (type === 'arr') {
            if (value && value.length > 0) {
              url = value[0].surfaceImg
            }
        } else {
            url = value.surfaceImg
        }
        url = url && url.includes('http') ? url : imgurl + url
        return url
      }
    },
    mounted() {
      this.newsList = this.newsData.news.slice(0,1);
      this.getAxtNewSourceList()
    },
    methods:{
      getAxtNewSourceList(){
        let websiteId = localStorage.getItem('websiteId');
        const that = this;
        const url = '/axt-mhcz/axtNewSource/getAxtNewSourceList';
        this.newsList.forEach(v=> {
          const params = {
             website_id:websiteId,
             // classify_id:v.dataNewsTypeId,
             // ids:v.dataNewsIds,
             cancel_publish:0,
           }
          if(v.dataType == 2){
            params.classify_id = v.dataNewsTypeId
            params.pageSize = v.dataSize
          }else if(v.dataType == 1) {
            params.ids = v.dataNewsIds
          }
            // console.log(params,"params")
           api.getListAPI(url, params).then(res => {
             if (res.data.message == 'success') {
               this.$set(this.dataobj, v.id, res.data.data.rows)
               //console.log(this.dataobj,'this.dataobj')
             }
           })
        })
      },
      tonewsList(){
        this.$router.push({path:'/newsList'})
        this.$nextTick(()=>{
          $("body").scrollTop(0);
        })
      }
    }
  }
</script>

<style scoped="scoped">
  .titlebtm {
   margin-bottom: 45px;
  }
  .newstitle {
    position: relative;
  }
  .newstitle .more {
    color: #3583FF;
    position: absolute;
    top: 80px;
    right: 20px;
    cursor: pointer;
  }
  .frtop {
    text-align: left;
    color: #212121;
    font-weight: 500;
  }
  .frtop .half {
    color: #DCDCDC;
    font-weight: 500;
  }
  .frtop img {
    height: 28px;
    position: relative;
    top: 4px;
  }
  .frnewsnum {
    float: left;
    width: 20px;
    height: 20px;
    margin-top: 5px;
    line-height: 20px;
    text-align: center;
    background: #EF5344;
    color: #FFFFFF;
  }
  .frnewscon {
    padding-left: 30px;
    margin-top: 18px;
  }
  .frnewscon .frnewscontitle {
    color: #212121;
    margin-bottom: 7px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .frnewscon .frnewscontent {
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    color: #666666;
  }
  .frnewsbox:hover .frnewscontitle {
    color: #3583FF;
  }
  #content {
    width: 1200px;
    margin-bottom: 40px;
  }
  .newsimgbox {
    margin-top: 45px;
    margin-bottom: 40px;
  }
  .newsimgbox .fl .imgbox {
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
  }
  .newsimgbox .fl .imgbox p {
    width: 100%;
    padding: 0 5%;
    position: absolute;
    left: 0;
    z-index: 1;
    bottom: 10px;
    color: #fff;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: all .5s;
  }
  .newsimgbox .fl {
    width: 600px;
    height: 330px;
  }
  .newsimgbox .fr {
    width: 580px;
    margin-left: 20px;
  }
  .newsimgbox .imgbox img {
    width: 100%;
    padding: 0;
    margin: 0;
    float: left;
    transition: all .5s;
  }
  .newsimgbox .fl .imgbox img {
    height: 100%;
  }
  .newsimgbox .fl .imgbox:hover img{
    transform: scale(1.1);
    transition: all .5s;
  }
  .newsimgbox .imgbox .mark {
    width: 100%;
    height: 50%;
    position: absolute;
    left: 0;
    bottom: 0;
    overflow: hidden;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  }
  .newsimgbox .fl .imgbox p {
    bottom: 30px;
  }
  /* .newsimgbox .imgbox:hover .mark, .frcon:hover .mark  {
    height: 100%;
    background: rgba(0,0,0,0.4);
  } */

  .newslist {
    text-align: left;
  }
  .con {
    background-color: #F5F5F7;
    border-radius: 10px;
    text-align: left;
  }
  .con .contitle {
    float: left;
    width: 76px;
    background: #3583FF;
    border-radius: 10px 0px 0px 10px;
    padding: 24px;
    line-height: 1.4;
    color: #fff;
  }
  .con .conbox {
    padding-left: 100px;
    padding-top: 20px;
  }
  .con .conbox p {
    width: 85%;
    margin-bottom: 20px;
    color: #555555;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .con .conbox p:hover {
    color:#3583FF ;
  }
  .con .conbox p:last-of-type {
    margin-bottom: 0;
  }
  .con .conbox p::before {
    content:"";
    display: block;
    float: left;
    width: 3px;
    height: 3px;
    position: relative;
    top: 10px;
    margin-right: 8px;
    background: #555555;
  }
  .con .more {
    position: absolute;
    bottom: 20px;
    right: 40px;
    color:#999999 ;
  }
  .con .more:hover {
    color:#3583FF ;
  }
  @media screen and (min-width: 1920px) {
    #content {
      width: 87.5%;
    }
    .newsimgbox .fl {
      width: 828px;
      height: 466px;
    }
    .newsimgbox .fr {
      width: 808px;
    }
    .newsimgbox .fl .imgbox {
      width: 828px;
    }
    .frnewscon {
      margin-top: 25px;
    }
    .frnewscon .frnewscontent {
      -webkit-line-clamp: 2;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/indexContent/eduNewsThree.vue